import React from 'react';

import { nodeTabClass } from '@/components/admin/SysadminSPA/shared/railClasses';
import cn from '@/utils/cn';

interface Props {
  active: boolean;
  children: React.ReactNode;
  onClick: () => void;
}

// The SPA's tab-row styling on a button: overrides the app's global <button> chrome (grey bg +
// all-sides border) so only the bottom accent shows on the active tab.
const TabButton = ({ active, children, onClick }: Props) => (
  <button
    className={cn(nodeTabClass(active), 'tw-cursor-pointer tw-bg-transparent tw-font-bold')}
    type="button"
    onClick={onClick}
  >
    {children}
  </button>
);

export default TabButton;
